module.exports = __webpack_public_path__ + "static/media/dadDish.ad631afe.jpg";